import { createAction, props } from '@ngrx/store';
import { ContextDetailsDto } from 'account-hybrid/common/models/context-details.dto';

export const setSingleContext = createAction(
    '[Contexts] Set single context',
    props<{ property: string }>()
);
export const setMultipleContext = createAction(
    '[Contexts] Set multiple context',
    props<{ properties: string[] }>()
);


export const loadContextDetails = createAction(
    '[Contexts] Load context details',
);
export const loadContextDetailsSuccess = createAction(
    '[Contexts] Load context details Success',
    props<{ details: ContextDetailsDto }>()
);
export const loadContextDetailsFailure = createAction(
    '[Contexts] Load context details Failure',
    props<{ error: any }>()
);
